import { Component, Input, OnChanges, OnInit } from '@angular/core';
import moment from 'moment';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {EventService} from '../../../../../core/services/event.service';

@Component({
    selector: 'event-block-component',
    templateUrl: './event-block.component.html',
    styleUrls: ['./event-block.component.scss'],
    standalone: true,
    imports: [SharedModule]
})
export class EventBlockComponentNew implements OnInit, OnChanges {
  @Input() event;
  public opacityColor;
  public _date;

  constructor(public eventService: EventService) {
  }

  getEventImage(name) {
    return this.eventService.getFileStream(name);
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    this.opacityColor = this.hexToRGB(this.event.eventType.color, 0.8);
    if (this.event.dates) {
      const dateArr = this.event.dates;
      if (dateArr.length) {
        this._date = moment(dateArr[0].date).format('DD. MMM YY');
      } else {
        this._date = '';
      }
    } else {
      this._date = '';
    }
  }

  hexToRGB(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }
}
